import moment from 'moment';

export function getTimelineLabel(weeksAgo) {
  const date = moment().startOf('isoWeek').subtract(weeksAgo, 'weeks').format('MMM D');
  switch (weeksAgo) {
    case 0:
      return `This Week (${date})`;
    case 1:
      return `Last Week (${date})`;
    default:
      return `${weeksAgo} weeks ago (${date})`;
  }
}
